/* eslint-disable no-magic-numbers */
import { MEGA } from "utils/common";
import { imageMaxBytes } from "social/utils";

export const MAX_IMAGE_BYTES = imageMaxBytes(30 * MEGA);
